import React, { useMemo, useState } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";

import {
  Breadcrumb,
  DataTable,
  DisplayOrder,
  SubHeading,
  Switch,
} from "../Components";
import {
  getAxios,
  getAxiosForAuthResponse,
  postAxios,
} from "../Services/commonService";
import {
  API_DELETE_IMAGES,
  API_GET_IMAGES,
  API_GET_WHITE_LABEL_SETTING,
  API_UPDATE_IMAGES,
} from "../utils/api/ApiConstant";
import UploadModal from "../Modal/GameModal/UploadModal";
import Icon from "../assets/icons/Icon";
import { CommonModal } from "../Modal";
import { useSelector } from "react-redux";

const Upload = () => {
  const [isShow, setIsShow] = useState({
    isOpen: false,
    rowData: null,
    name: "",
    modalTitle: "",
    modalContent: null,
    apiFlag: false,
  });
  const queryClient = useQueryClient();
  const { pagePermission } = useSelector((state) => state.user);

  const { isLoading, data } = useQuery({
    queryKey: ["uploadData", isShow.apiFlag],
    queryFn: async () => await getAxios(API_GET_IMAGES, {}),
  });

  const { data: whtLabel } = useQuery({
    queryKey: ["whtLabelData"],
    queryFn: async () =>
      await getAxiosForAuthResponse(API_GET_WHITE_LABEL_SETTING, {
        page: 1,
        limit: 10,
      }),
  });

  const handleDelete = async (apiUrl) => {
    const res = await postAxios(API_DELETE_IMAGES, { apiName: apiUrl });
    if (res) {
      setIsShow((prev) => ({
        ...prev,
        apiFlag: !prev.apiFlag,
      }));
    }
  };

  const handleQueryClient = (rowData, updatedRowData, key) => {
    const data = queryClient.setQueryData(
      ["uploadData", isShow.apiFlag],
      (oldData) => {
        if (!oldData) return oldData;

        return oldData.map((obj) =>
          obj.apiUrl === rowData.apiUrl
            ? { ...obj, [key]: updatedRowData[key] }
            : obj
        );
      }
    );

    return data;
  };

  const handlePutRequest = async (url, rowData, newValue, key) => {
    const updatedRowData = {
      ...rowData,
      [key]: newValue,
    };
    const res = await postAxios(url, updatedRowData);

    if (res) {
      handleQueryClient(rowData, updatedRowData, key);
    }
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "apiName",
        header: "Image Name",
      },
      {
        accessorKey: "type",
        header: "type",
      },
      {
        accessorKey: "apiUrl",
        header: "Image url",
      },
      {
        accessorKey: "isActive",
        header: "isActive",
        cell: ({ getValue, row }) => {
          return (
            <Switch
              getValue={getValue}
              onChange={() => {
                handlePutRequest(
                  API_UPDATE_IMAGES,
                  row?.original,
                  !getValue(),
                  "isActive"
                );
              }}
              disabled={pagePermission?.isActive ? false : true}
            />
          );
        },
      },
      {
        accessorKey: "whitelableTypes",
        header: "whitelabel",
      },
      {
        accessorKey: "action",
        header: "Action",
        cell: ({ row }) => {
          const initialValue = row.original.displayOrder;

          return (
            <div className="action_icon_box">
              <DisplayOrder
                initialValue={initialValue}
                onConfirm={(newValue) =>
                  handlePutRequest(
                    API_UPDATE_IMAGES,
                    row?.original,
                    newValue,
                    "displayOrder"
                  )
                }
              />

              <Icon
                name="FaRegTrashAlt"
                onClick={() => handleDelete(row?.original?.apiUrl)}
                cursorPointer={true}
                className=" icon_button btn btn-outline-danger "
              />
            </div>
          );
        },
      },
    ],
    []
  );

  const fetchData = () => {
    if (!data) return { data: [], pages: 0 };

    return {
      data: data,
      pages: data.pages || 0,
    };
  };

  return (
    <>
      {/* <Breadcrumb breadcrumb={[]} title={"Upload"} /> */}
      <SubHeading
        subTitle="upload list"
        handleShowHide={() =>
          setIsShow((prev) => ({
            ...prev,
            isOpen: true,
            rowData: {},
            name: "add",
            modalTitle: "Add Upload",
            modalContent: UploadModal,
          }))
        }
        createAccess={pagePermission?.createAccess}
      />
      <div className="card-body">
        <DataTable
          columns={columns}
          fetchData={fetchData}
          isSearchable={false}
          isPagination={false}
          isPageSize={false}
          isLoading={isLoading}
        />
      </div>

      {/* Modal for Add/Edit Sport */}
      <CommonModal
        isShow={isShow.isOpen}
        handleShowHide={() =>
          setIsShow((prev) => ({
            ...prev,
            isOpen: false,
            rowData: {},
            name: "",
          }))
        }
        modalTitle={isShow.modalTitle}
      >
        {isShow.modalContent &&
          React.createElement(isShow.modalContent, {
            handleShowHide: () =>
              setIsShow((prev) => ({
                ...prev,
                isOpen: false,
                rowData: {},
                name: "",
                modalTitle: "",
                apiFlag: !prev.apiFlag,
              })),
            rowData: isShow.rowData,
          })}
      </CommonModal>
    </>
  );
};

export default Upload;
